var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 0.666687C18.2267 0.666687 19.0267 1.10669 19.5067 1.78669L25.3333 10L19.5067 18.2134C19.0267 18.8934 18.2267 19.3334 17.3333 19.3334L2.66667 19.32C1.2 19.32 0 18.1334 0 16.6667V3.33335C0 1.86669 1.2 0.68002 2.66667 0.68002L17.3333 0.666687ZM2.66667 16.6667H17.3333L22.0667 10L17.3333 3.33335H2.66667V16.6667Z",
    fill: "#0029F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOutline);
export default __webpack_public_path__ + "static/media/SalesOutline.43402327fe1c16f0cd32bb20c6c5a92d.svg";
export { ForwardRef as ReactComponent };